import React, { useState, useEffect } from "react";
import BriefSummary from "./BriefSummary";
import ClientDetails from "./ClientDetails";
import HotelContact from "./HotelContact";
import EnquiryFiles from "./EnquiryFiles";
import AgencySpecific from "./AgencySpecific";
import {
  isAgencyAdmin,
  isAgencyUser,
  isRoleEdgeAdmin,
  isRoleTrinity,
  isSuperAgent,
} from "../../modules/permissions";

import { isAgency, isVenue, token } from "../../modules/auth";
import { connect } from "react-redux";
import ManagedTrinityUser from "./ManagedTrinityUser";
import RfpAgencyNotes from "./RfpAgencyNotes";
import VenueConfirmedInformation from "./VenueConfirmedInformation";
import EditInitialResponse from "./EditInitialResponse";
import NotificationTracking from "./NotificationTracking";
import LinkedEnquiries from "./LinkedEnquiries";
import { ENQUIRY_VENUE_DATA_STATUS } from "../../modules/rfp/enquiryVenueDataStatus";

import { Field, reduxForm, change, getFormValues } from "redux-form";
import VenueUserCarbonInfomation from "./VenueUserCarbonInfomation";
import { checkVenueForPreferredProgramme } from "../../services/hotelGroupService/preferredProgrammesService";
import venue from "../../pages/Venue";
import CommercialDeals from "./CommercialDeals";
import { WhitePanelWithHeader } from "../../ui";
import CompanyNoteField from "../corporate/CompanyNoteField";
import { BOOKED_EVENT_STATUS } from "../../constants";
import VenueCompletedInformation from "./VenueCompletedInformation";

const mapStateToProps = state => {
  return {
    ...state.notes,
    isSuperAgent: isSuperAgent(state.auth),
    isRoleTrinity: isRoleTrinity(state.auth),
    isRoleEdgeAdmin: isRoleEdgeAdmin(state.auth),
    isAgencyUser: isAgencyUser(state.auth),
    isAgencyAdmin: isAgencyAdmin(state.auth),
    isVenue: isVenue(state),
    isAgency: isAgency(state),
    token: token(state),
  };
};

const RfpBriefSection = ({
  brief,
  clientDetails = {}, // todo remove default
  companyDetails = {}, // todo remove default
  expanded,
  contacts,
  setShowContactForm,
  values,
  venueId,
  rfpId,
  validation,
  form,
  checksheet,
  agencySpecificData = {},
  managingTrinityUser = {},
  isRoleTrinity,
  isSuperAgent,
  isRoleEdgeAdmin,
  isVenue,
  notes = {},
  isAgency,
  initialResponse,
  venueSlug,
  event,
  briefPreferences,
  enquiryVenueData,
  token,
  isAgencyUser,
  isAgencyAdmin,
  hideBriefForVenueUser
}) => {
  const [isInProgramme, setIsInProgramme] = useState([]);
  useEffect(() => {
    checkVenueForPreferredProgramme(token).then(response => {
      setIsInProgramme(response);
    });
  }, []);
  return (
    <>
      <div className="w-full">
        {!hideBriefForVenueUser ?  <BriefSummary
          admin
          expanded={expanded}
          {...brief}
          briefPreferences={briefPreferences}
          isVenue={isVenue}
          enquiryVenueData={enquiryVenueData}
        /> : null }

      </div>
      <div className="w-full">
        {brief.attachments && brief.attachments.length > 0 && (
          <EnquiryFiles
            admin
            expanded={expanded}
            attachments={brief.attachments}
          />
        )}
      </div>
      <div className="xl:flex">
        {managingTrinityUser &&
        Object.values(managingTrinityUser).length > 0 &&
        (isVenue ||
          isAgencyUser ||
          isAgencyAdmin ||
          isSuperAgent ||
          isRoleEdgeAdmin) ? (
          <div className={`xl:mr-5 ${hideBriefForVenueUser ? "xl:w-full" : "xl:w-2/5" }`}>
            <ManagedTrinityUser
              {...managingTrinityUser}
              isInProgramme={isInProgramme}
              venueId={
                venueId ? venueId : event && event.venue ? event.venue.id : null
              }
            />
          </div>
        ) : (
          <div className="xl:mr-5 xl:w-2/5">
            {agencySpecificData.share_with_venues && isVenue ? (
              <ClientDetails
                {...clientDetails}
                clientName={agencySpecificData.client_name}
                original_client={agencySpecificData.original_client}
                label={"Client Details"}
                isInProgramme={isInProgramme}
                venueId={
                  venueId
                    ? venueId
                    : event && event.venue
                    ? event.venue.id
                    : null
                }
              />
            ) : (
              <ClientDetails
                {...clientDetails}
                label={isVenue || isAgency ? "Agent Details" : "Client Details"}
                isInProgramme={isInProgramme}
                venueId={
                  venueId
                    ? venueId
                    : event && event.venue
                    ? event.venue.id
                    : null
                }
              />
            )}
          </div>
        )}
        {isVenue && agencySpecificData.share_with_venues > 0 && (
          <div className="xl:mr-5 xl:w-2/5">
            <AgencySpecific
              expanded
              {...agencySpecificData}
              label={"Client Details"}
              isInProgramme={isInProgramme}
              venueId={
                venueId ? venueId : event && event.venue ? event.venue.id : null
              }
            />
          </div>
        )}

        {(isSuperAgent || isAgencyUser || isAgencyAdmin || isRoleEdgeAdmin) &&
          agencySpecificData && (
            <div className="xl:mr-5 xl:w-2/5">
              <AgencySpecific
                expanded
                {...agencySpecificData}
                label={"Client"}
                isInProgramme={isInProgramme}
                venueId={
                  venueId
                    ? venueId
                    : event && event.venue
                    ? event.venue.id
                    : null
                }
              />
            </div>
          )}
        {values && (
          <div className="xl:mr-5 xl:w-2/5">
            <HotelContact
              contacts={contacts}
              currentContact={enquiryVenueData.venue_contact}
              setShowContactForm={setShowContactForm}
              values={values}
              venueId={venueId}
              rfpId={rfpId}
              validation={validation}
              form={form}
              checksheet={checksheet}
            />
          </div>
        )}

        {(isSuperAgent ||
          isAgencyUser ||
          isAgencyAdmin ||
          isRoleEdgeAdmin ||
          isAgency ||
          isVenue) && (
          <EditInitialResponse
            initialResponse={initialResponse}
            rfpId={rfpId}
            venueSlug={venueSlug}
          />
        )}
      </div>

      {isSuperAgent ? (
        <div className="w-full">
          <LinkedEnquiries
            expanded={false}
            rfpId={rfpId}
            label={"Linked Enquiries"}
            token={token}
          />
        </div>
      ) : null}

      {(isRoleEdgeAdmin || isAgency) &&
      enquiryVenueData &&
      enquiryVenueData.proposal_data
        .edge_platform_selected_commercial_deal_id ? (
        <div className="w-full">
          <CommercialDeals
            expanded={false}
            enquiryVenueDataId={enquiryVenueData.id}
            label={"Commercial Deal"}
            token={token}
          />
        </div>
      ) : null}

      <NotificationTracking
        expanded
        token={token}
        enquiryId={rfpId}
        enquiryVenueDataId={enquiryVenueData?.id}
      />

      {(isAgency || isRoleEdgeAdmin) && (
        <div className={"w-full"}>
          <RfpAgencyNotes notes={notes} rfpId={rfpId} />
        </div>
      )}
      {(isAgency || isRoleEdgeAdmin) &&
        companyDetails &&
        companyDetails.name &&
        companyDetails.note && (
          <div className={"w-full"}>
            <WhitePanelWithHeader
              title={"Company Note"}
              collapsible
              defaultOpen={expanded}
            >
              <CompanyNoteField
                company={companyDetails.name}
                note={companyDetails.note}
                displayNote={true}
              />
            </WhitePanelWithHeader>
          </div>
        )}
      {isVenue && event && event.has_valid_carbon_impact && (
        <VenueUserCarbonInfomation event={event} />
      )}
      {isVenue &&
        enquiryVenueData &&
        event &&
        event.requires_invoicing &&
        (parseInt(event.event_status.code) >= BOOKED_EVENT_STATUS.PENDING_INVOICE ||
          parseInt(event.event_status.code) === BOOKED_EVENT_STATUS.CONFIRMED) &&
        enquiryVenueData.status < ENQUIRY_VENUE_DATA_STATUS.ALTERNATIVE_VENUE_BOOKED &&
        enquiryVenueData.status > ENQUIRY_VENUE_DATA_STATUS.VENUE_AMENDS && (
          <div className="w-full">
            <VenueConfirmedInformation event={event} />
          </div>
        )}
      {isVenue &&
        enquiryVenueData &&
        event &&
        event.requires_invoicing &&
        (parseInt(event.event_status.code) >= 30) &&
        enquiryVenueData.status <
        ENQUIRY_VENUE_DATA_STATUS.ALTERNATIVE_VENUE_BOOKED &&
        enquiryVenueData.status > ENQUIRY_VENUE_DATA_STATUS.VENUE_AMENDS && !managingTrinityUser && (
          <div className="w-full">
            <VenueCompletedInformation event={event} />
          </div>
        )}
    </>
  );
};

export default connect(mapStateToProps, null)(RfpBriefSection);
